import { useState } from "react";
import Button from "../../../components/shared/buttons/button";
import GridCard from "../../../components/shared/gridCard/GridCard";
import Datatable from "../../../components/shared/datatable/Datatable";
import CaseColdStorage from "../../../images/cold_storage.svg";
import ColdStorageKg from "../../../images/material_orange.svg";
import TotalCase from "../../../images/totalCase.svg";
import { useSearchRecordQuery } from "./coldstorageApi";
import ColdStorageModal from "./ColdStorageModal";
import { useGetRipeningColdStorageSummaryQuery } from "../dashboard/ripeingDashboardApi";
import RipeningOverViewModal from "../overview/RipeningOverViewModal";
import { DEFAULT_DATE_FORMAT, DEFAULT_DATETIME_FORMAT, PROJECT_DATE_FORMAT } from "../../../helpers/constants";
import { convertToUserTimezone, formatDateAndTime, formatPalletName, getCurrentDate } from "../../../helpers/Utils";
import useTranslator from "../../../hooks/useTranslator";
import { getAppTz } from "../../../helpers/Utils";
import moment from "moment-timezone";


const ColdStorage = () => {
  const { _t } = useTranslator();
  const [page, setPage] = useState(1);
  const [showModal, setShowModal] = useState(false);
  // const [status, setStatus] = useState(["washing_ready", "counting"]);
  const [showOverviewModal, setShowOverviewModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [addRecord, setAddRecord] = useState(false);
  const currentDate = getCurrentDate();
  const [date, setDate] = useState(currentDate);
  const [tab, setTab] = useState("cold_storage");
  const { data: summaryData } = useGetRipeningColdStorageSummaryQuery({ tab });
  const [filter, setFilter] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({
    entered_date: "",
    pallet_code: "",
    status: "",
  });

  const handleFilterApply = (newFilters) => {
    setAppliedFilters(newFilters);
    setFilter(newFilters);
  };
  const {
        data: record,
        isLoading,
        isFetching,
      } = useSearchRecordQuery({
        page,
        ...filter,
      });

  const listItems = [
    {
      label: _t("total_no_of_pallets", "Total Pallets"),
      value: summaryData?.data.total_pallets_in_cold_storage,
      icon: TotalCase,
    },
    {
      label: _t("total_cold_storage_cases", "Total Cases in Cold Storage"),
      value: summaryData?.data.total_cases_in_cold_storage,
      icon: CaseColdStorage,
    },
    {
      label: _t("total_fruit_entered_kg", "Total Fruit entered in KG"),
      value: summaryData?.data.total_kg_in_cold_storage,
      icon: ColdStorageKg,
    },
  ];
  const handlePageChange = (page) => {
    setPage(page);
  };  
  const handleView = (unloading) => {
    setSelectedRecord(unloading);
    setShowOverviewModal(true);
  };
  const handleEdit = (unloading) => {
    setAddRecord(true);
    setModalMode("edit");
    setSelectedRecord(unloading);
    setShowModal(true);
  };

  const getStatus = (row) => {
    if (row?.row?.status !== "cold_stored") {
      return "Ripening";
    }

    const timezone = getAppTz();

    const expectedDate = moment
      .utc(row?.row?.expected_date_to_ripening)
      .tz(timezone)
      .startOf("day");

    const today = moment().tz(timezone).startOf("day");

    if (!expectedDate.isValid()) {
      return "Cold Stored";
    }

    return today.isBefore(expectedDate)
      ? "Cold Stored"
      : "Ready For Ripening";
  };

  const columns = [
    {
      label: _t("date", "Date"),
      accessor: "entered_date_time",
      cell: ({ value }) =>{
        return convertToUserTimezone(value);
      }
    },   
    {  
      label: _t("expected_date_to_ripening", "Expected Date To Ripening"),
      accessor: "expected_date_to_ripening",
      cell: ({ value }) =>{
        return convertToUserTimezone(value,DEFAULT_DATE_FORMAT);
      }
    },   
    { label: _t("pallet_code", "Pallet Code"), accessor: "pallet_code", cell: ({ value }) => formatPalletName(value) },
    { label: _t("case_entered", "Case Entered"), accessor: "case_entered" },
    {
      label: _t("weight_entered", "Weight Entered"),
      accessor: "fruit_entered_in_kg",
    },    
    {
      label: _t("exit_date_time", "Exit Date and Time"),
      accessor: "exit_date_time_to_ripening",
      cell: (row) => {
        if (
          !row?.row?.exit_date_time_to_ripening ||
          row?.row?.status !== "ripening"
        ) {
          return _t("no_data_yet", "No data yet");
        }

        return convertToUserTimezone(
          row.row.exit_date_time_to_ripening
        );
      },
    },
    {
      label: _t("status", "Status"),
      accessor: "status",
      cell: (row) => (
        <span
          className={
            getStatus(row) === "Cold Stored"
              ? "cmn_badge inactive"
              : getStatus(row) === "Ready For Ripening"
              ? "cmn_badge"
              : "cmn_badge rejected"
          }
        >
          {getStatus(row)}
        </span>
      ),
    },

    {
      label: _t("overview", "Overview"),
      accessor: "status",
      cell: ({ row }) => (
        <>
          <Button
            size="small"
            label={
              row.status === "ripening"
                ? _t("view", "View")
                : _t("edit", "Edit")
            }
            className={row.status === "ripening" ? "borderRedBtn" : ""}
            onClick={
              row.status === "ripening"
                ? () => handleView(row)
                : () => handleEdit(row)
            }
          />
        </>
      ),
    },
  ];
  // console.log(`addRecord :: ${addRecord} || showOverviewModal :: ${showOverviewModal}`)
  return (
    <div>
      {addRecord && (
        <ColdStorageModal
          show={showModal}
          setShow={setAddRecord}
          mode={modalMode}
          record={selectedRecord}
        />
      )}
      {showOverviewModal && (
        <RipeningOverViewModal
          show={showOverviewModal}
          setShow={setShowOverviewModal}
          record={selectedRecord}
          mode="cold-storage"
        />
      )}
      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">
            {_t("cold_storage_overview", "Cold Storage Overview")}
          </h6>
          {/* <DateSelector setDate={setDate} /> */}
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date, PROJECT_DATE_FORMAT)}
            />
          ))}
        </ul>
      </div>
      {(isLoading || isFetching) &&   (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      )}
      {!isLoading &&  !isFetching  && (
      <Datatable
        title={_t("cold_storage_log", "Cold Storage Log")}
        columns={columns}
        tableData={record?.data}
        // buttons={[
        //   {
        //     label: _t("add_cases_cold_storage", "Add Cases in Cold Storage"),
        //     onClick: handleAddRecord,
        //     icon: PlusSvg,
        //   },
        // ]}
        totalRecordsTitle={_t("total_records", "Total Records")}
        showPagination={true}
        pagination
        page={page}        
        onPageChange={handlePageChange}
        showFilter={handleFilterApply}
        showFilterButton={true}
        filterModule="coldStorage"
        filters={appliedFilters}
      />
      )}
    </div>
  );
};

export default ColdStorage;
